<template>
  <div class="body">
    <div class="text-center">
      <span v-if="template" v-html="template"></span>
      <span>{{ $t(text) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    template: {
      required: false
    },
    text: {
      required: false
    }
  },
  mounted () {
  }
}
</script>

<style lang="sass" scoped>
.body
  padding: 1rem
.text-center
  align-items: center
</style>
